export default __webpack_public_path__ + "static/media/ProfilePicture.be60f1a7.png";